import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as CryptoJS from "crypto-js";
import { FormBuilder, FormControl, FormGroup, SelectMultipleControlValueAccessor, Validators } from '@angular/forms';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';
import { TabService } from 'src/app/utils/TabService';
import { State } from 'src/app/shared/models/State';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';

@Component({
  selector: 'app-church-detail',
  templateUrl: './church-detail.component.html',
  styleUrls: ['./church-detail.component.scss'],
  providers: [MessageService, ConfirmationService, TabService]
})

export class ChurchDetailComponent implements OnInit {

  // CHURCH REGISTER FORM
  churchRegisterForm: FormGroup;
  churchParent: any;
  security: SecurityDocument;
  currentUser: any;
  selLang: string;

  dataParent: any;
  countries: any[];
  profileUser: any;
  selectedCountry: any;
  listState: State[];
  selectedState: State = null;
  lstTypesChurch: CategoryLan[];
  selectedTypeChurch: CategoryLan;

  // LANGUAGE

  lbl_go_Back: string = "back_";
  lbl_country: string = "country_";
  lbl_church_name: string = "church_name_";
  lbl_state: string = "state_";
  lbl_city: string = "city_";
  lbl_select: string = "select_";
  lbl_type: string = "type_";
  lbl_search: String = "search_";
  lbl_churchs_chapels_parish: string = "churchs_chapels_parish_";
  lbl_name: string = "name_";
  lbl_short_name: string = "short_name_";
  lbl_street_and_number: string = "street_and_number_";
  lbl_neightborhood: string = "neightborhood_";
  lbl_zip_code: string = "zip_code_";
  lbl_telephones_number: string = "telephones_number_";
  lbl_comments: string = "comments_";
  lbl_save: string = "save_";
  lbl_delete_record: string = "delete_record_";
  lbl_personal_information: string = "personal_information_";
  lbl_address: string = "address_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_";


  // SAVE 
  button_save: boolean;

  cities: { name: string; code: string; }[];
  selectedCity: { name: string; code: string; };

  /**
   * The constructor initializes various services and authenticates the user using a specific method.
   * @param {FormBuilder} formBuilder - A service provided by Angular that helps in building and managing
   * forms in a reactive way.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success messages, error messages, and warning messages.
   * @param {ConfirmationService} confirmationService - The ConfirmationService is a service provided by
   * PrimeNG, a UI component library for Angular. It provides methods for displaying confirmation dialogs
   * to the user, allowing them to confirm or cancel an action.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to retrieve information about the currently activated route. It contains information
   * about the route's parameters, data, and URL segments. It is typically used in Angular applications
   * to retrieve data from the URL and pass it to
   * @param {AuthenticationService} authenticationService - This parameter is an instance of the
   * AuthenticationService class, which is used for handling user authentication and authorization. It is
   * likely used in this code to check if the user is authenticated before allowing access to certain
   * parts of the application.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between components.
   */
  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;
    this.currentUser = this.authenticationService.currentUserValue;

  }


  /**
   * The function initializes form declarations and retrieves security information.
   */
  ngOnInit(): void {
    this.churchRegisterForm = this.formBuilder.group({
      "country": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "stateDptoProvince": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "city": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "type": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "nameChurch": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "shortName": new FormControl("", [
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(1),
      ]),
      "downtown": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(1),
      ]),
      "streetNumber": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "postalCode": new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(1),
      ]),

      "phoneNumber": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(1),
      ]),
      "comments": new FormControl("", [
        Validators.maxLength(50),
        Validators.minLength(1),
      ]),
    });

    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.churchParent = this.dataParent.church;
      this.countries = this.dataParent.countries;
      this.listState = this.dataParent.states;
      this.profileUser = this.dataParent.profileUser;
      console.log(this.security);
      if (this.dataParent.selectedCountry) {
        this.selectedCountry = this.dataParent.selectedCountry;
        this.selectedState = this.dataParent.selectedState;
        this.selectedCity = this.dataParent.selectedCity;
        this.churchRegisterForm.controls["city"].setValue(this.dataParent.selectedCity != null ? this.dataParent.selectedCity.value : "");
      }

      this.getSecurity();



    } else {

      this.redirectChurchList();

    }



    // LANG
    this.route.queryParams
      .subscribe(
        params => {

          this.selLang = params.language;
        });

    // FORMS DECLARATIONS 



  }

  /**
   * The function resets a user form by calling the reset method on a validation object.
   */
  resetForms() {
    this.churchRegisterForm.reset();
  }

  /**
   * This function recursively marks all form controls in a FormGroup as touched.
   * @param {FormGroup} formGroup - A FormGroup object that represents a group of FormControls. It is
   * used to manage the validation and submission of a group of related form controls.
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   * This function authenticates a user by calling a login function and subscribing to the response.
   * @param {string} user - a string representing the usernameChurch of the user trying to authenticate.
   * @param {string} password - A string representing the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.currentUser = this.authenticationService.currentUserValue;
            this.getSecurity();
          }
        },
        error => {
          console.error(error);
        });
  }

  /**
   * The function retrieves security information for the current user and sets the language and
   * translated labels accordingly.
   */
  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;
        console.log(data);
        if (this.security) {
          this.getTranslatedLabels();
          this.getTypesChurchServices();

          if (this.dataParent.church) {
            this.loadDataChurch();
          } else {
            if (this.countries == null || this.countries.length <= 0) {
              this.getCountriesServices();
            } else {
              if (!this.selectedCountry) {
                this.selectedCountry = this.countries.find(s => s.countryId === this.security.region);
              }
            }

            if (!this.selectedState && this.listState != null && this.listState.length > 0) {
              this.selectedState = this.listState.find(s => s.id.stateId === this.profileUser.address.state);
            }


          }

        }
      });
  }

  /**
   * This function retrieves translated labels from an API and updates the corresponding variables with
   * the translated values.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.selLang != null ? this.selLang : window.navigator.language.split("-")[0],
      'region': this.security.region,
      'lstLabels': [this.lbl_personal_information, this.lbl_address, this.lbl_go_Back, this.lbl_country, this.lbl_state, this.lbl_city, this.lbl_select, this.lbl_type, this.lbl_search, this.lbl_churchs_chapels_parish, this.lbl_name, this.lbl_street_and_number, this.lbl_neightborhood, this.lbl_zip_code, this.lbl_telephones_number, this.lbl_comments, this.lbl_save, this.lbl_delete_record, this.lbl_church_name, this.lbl_short_name, this.lbl_are_you_sure, this.lbl_yes, this.lbl_no]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_personal_information = map.get(this.lbl_personal_information);
        this.lbl_address = map.get(this.lbl_address);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_country = map.get(this.lbl_country);
        this.lbl_state = map.get(this.lbl_state);
        this.lbl_city = map.get(this.lbl_city);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_churchs_chapels_parish = map.get(this.lbl_churchs_chapels_parish);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_street_and_number = map.get(this.lbl_street_and_number);
        this.lbl_neightborhood = map.get(this.lbl_neightborhood);
        this.lbl_zip_code = map.get(this.lbl_zip_code);
        this.lbl_telephones_number = map.get(this.lbl_telephones_number);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_short_name = map.get(this.lbl_short_name);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);

      });
  }

  /**
   * The function "goBack" closes the current window.
   */
  goBack() {
    this.redirectChurchList();
  }

  /**
   * The function "registerChurch" is declared with an event parameter.
   * @param event - The parameter "event" is likely referring to an event object that is passed as an
   * argument to the "registerChurch" function. This event object could contain information about an
   * event that triggered the function to be called, such as a button click or form submission. The
   * function may use this information to perform
   */
  registerChurch(event) {
    this.confirmationService.confirm({
      message: '¿ ' + this.lbl_are_you_sure + ' ' + this.lbl_save + ' ' + this.lbl_church_name + ' ?',
      header: this.lbl_save + ' ' + this.lbl_church_name,
      icon: 'pi pi-home',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.createUpdateChurch();
      }
    });
  }


  createUpdateChurch() {
    this.button_save = true;
    let method: string = this.churchParent != null && this.churchParent.chr ? "UPDATE" : "CREATE";
    const body = {
      guideId: this.security.guideId,
      language: this.security.language,
      method: method,
      church: {
        churchId: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.churchId : null,
        address: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.address : null,
        cancelSts: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.cancelSts : null,
        decan: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.decan : null,
        status: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.status : "N",
        storeId: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.storeId : this.security.storeId,
        toPost: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.toPost : null,
        name: this.churchRegisterForm.controls["nameChurch"].value,
        comments: this.churchRegisterForm.controls["comments"].value,
        shortName: this.churchRegisterForm.controls["shortName"].value,
        type: this.selectedTypeChurch.fieldVal,
        vicar: this.churchParent != null && this.churchParent.chr != null ? this.churchParent.chr.vicar : null,
        userId: this.security.userId
      },
      address: {
        addrId: this.churchParent != null && this.churchParent.ab != null ? this.churchParent.ab.addrId : null,
        city: this.churchRegisterForm.controls["city"].value,
        country: this.selectedState.id.countryId,
        neight: this.churchRegisterForm.controls["downtown"].value,
        personType: this.churchParent != null && this.churchParent.ab != null ? this.churchParent.ab.personType : null,
        state: this.selectedState.id.stateId,
        storeId: this.churchParent != null && this.churchParent.ab != null ? this.churchParent.ab.storeId : this.security.storeId,
        street: this.churchRegisterForm.controls["streetNumber"].value,
        tel1: this.churchRegisterForm.controls["phoneNumber"].value,
        zipCode: this.churchRegisterForm.controls["postalCode"].value,
      }

    }

    this.apiService.crudChurch(body).then(
      data => {

        if (data && data.status.trim() == 'OK') {
          this.resetForms();
          this.button_save = false;
          this.messageService.add({ key: "tst", severity: 'success', summary: 'Guarda Parroquia', detail: "Se creo parroquia correctamente", life: 5000 });
          this.redirectChurchList()
        } else {
          this.button_save = false;
          this.messageService.add({ key: "tst", severity: 'error', summary: 'Guarda Parroquia: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        this.button_save = false;
        console.error(error);
        this.messageService.add({ key: "tst", severity: 'error', summary: 'Guarda Parroquia' + error + "/", detail: "Error al Guardar Parroquia" + error + "/", life: 3000 });
      });







  }


  redirectChurchList() {
    let obj = {
      selectedCountry: this.dataParent && this.dataParent.selectedCountry != null ? this.dataParent.selectedCountry : null,
      selectedState: this.dataParent && this.dataParent.selectedState != null ? this.dataParent.selectedState : null,
      selectedCity: this.dataParent && this.dataParent.selectedCity != null ? this.dataParent.selectedCity : null
    }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['catalogs/churchList'], navigationExtras);
  }



  /**
   * The function "deleteChurch" is declared in TypeScript but its implementation is missing.
   * @param event - The "event" parameter is likely referring to an event object that is passed as an
   * argument to the "deleteChurch" function. This event object could contain information about the event
   * that triggered the function, such as a mouse click or a keyboard press. However, since the function
   * body is empty, it
   */
  deleteChurch(event) {
    this.confirmationService.confirm({
      message: '¿ ' + ' ' + this.lbl_are_you_sure + ' ' + this.lbl_delete_record + ' ' + this.lbl_church_name + ' ?',
      header: this.lbl_delete_record,
      icon: 'pi pi-home',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteChurchServices();
      }
    });

  }

  deleteChurchServices() {
    const body = {
      guideId: this.security.guideId,
      language: this.security.language,
      method: "DELETE",
      church: this.churchParent.chr,
      address: this.churchParent.ab

    }
    this.apiService.crudChurch(body).then(
      data => {

        if (data && data.status.trim() == 'OK') {
          this.resetForms();
          this.button_save = false;
          this.messageService.add({ key: "tst", severity: 'success', summary: 'Eliminar Parroquia', detail: "Se elimino parroquia correctamente", life: 5000 });
          this.redirectChurchList()
        } else {
          this.button_save = false;
          this.messageService.add({ key: "tst", severity: 'error', summary: 'Eliminar Parroquia: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        this.button_save = false;
        console.error(error);
        this.messageService.add({ key: "tst", severity: 'error', summary: 'Eliminar Parroquia' + error + "/", detail: "Error al eliminar Parroquia" + error + "/", life: 3000 });
      });
  }

  getCountriesServices() {
    this.apiService.getCountries().then(countries => {
      this.countries = countries;

      if (this.security && !this.selectedCountry) {
        this.selectedCountry = this.countries.find(s => s.countryId === this.security.region);
      }

    });
  }

  loadDataChurch() {

    this.churchRegisterForm.controls["nameChurch"].setValue(this.churchParent.chr.name);
    this.churchRegisterForm.controls["shortName"].setValue(this.churchParent.chr.shortName);
    this.churchRegisterForm.controls["comments"].setValue(this.churchParent.chr.comments);
    this.churchRegisterForm.controls["city"].setValue(this.churchParent.ab.city);
    this.churchRegisterForm.controls["postalCode"].setValue(this.churchParent.ab.zipCode);
    this.churchRegisterForm.controls["downtown"].setValue(this.churchParent.ab.neight);
    this.churchRegisterForm.controls["streetNumber"].setValue(this.churchParent.ab.street);
    this.churchRegisterForm.controls["phoneNumber"].setValue(this.churchParent.ab.tel1);


    this.selectedCountry = this.countries.find(s => s.countryId === this.churchParent.ab.country);
    this.selectedState = this.listState.find(s => s.id.stateId === this.churchParent.ab.state);

  }

  getTypesChurchServices() {
    this.apiService.getCategoryLang({
      'language': this.security.language,
      'fieldId': "churchType"
    }).then(categoryLangResp => {
      this.lstTypesChurch = categoryLangResp;
      if (this.churchParent) {
        this.selectedTypeChurch = this.lstTypesChurch.find(s => s.fieldVal === this.churchParent.chr.type);
      }


    });
  }

  getStatesServices(country: string) {
    this.apiService.getStatesByCountry(country).then(
      data => {
        this.listState = data;

      });
  }
}
